import styled, { css } from "styled-components";
interface RechargeCardProps {
  width?: string;
  height?: string;
  isActive: boolean;
  padding?: string;
  gap?: string; // 金额模块与福利模块间距
}

export const TopUpPageContainer = styled.div`
  width: 1342px;
  margin: 0px auto 20px;
  padding-bottom: 18px;
  position: relative;
  z-index: 0;
`;
export const TopUpContainer = styled.div`
  display: flex;
  height: 100%;
  border: 1px solid #343538;
  border-radius: 4px;
  background: #292b2f;
  .renderbus-ui-tab {
    flex: 1 1 0%;
    max-width: 1012px;
  }
`;

export const UserInfoContainer = styled.div`
  width: 330px;
  border-left: 1px solid #3a4449;
  padding: 24px 16px;
  background: #2c2e32;
  box-shadow: -11px 0px 8px 0px #0000001a;
`;

export const CommonContainer = styled.div`
  padding: 20px 16px 20px 24px;
`;

export const CommonCardListWrapper = styled.div<{ mT?: string; pT?: string }>`
  display: flex;
  margin-top: ${(p) => p.mT || "0px"};
  padding-top: ${(p) => p.pT || "12px"};
  gap: 14px;
`;

export const beforeCss = css`
  ::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: inherit;
    padding: 4px;
    box-sizing: border-box;
    background: linear-gradient(141.29deg, #0dc770 30.94%, #55bcf6 106.39%);
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: destination-out;
    mask-composite: exclude;
  }
`;

export const CommonRechargeCard = styled.div<RechargeCardProps>`
  position: relative;
  width: ${(p) => p.width || "224px"};
  height: ${(p) => p.height || "134px"};
  background: ${(p) => (p.isActive ? "rgba(19, 203, 117, 0.04)" : "#292B2F")};
  border-radius: 8px;
  padding: ${(p) => p.padding || "18px 16px"};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.gap || "6px"};
  box-shadow: inset 0 0 0 1px rgba(73, 83, 89, 1);
  ${(p) => p.isActive && beforeCss}
  .recharge-price {
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 500;
    font-size: 16px;
    height: 36px;
    width: 100%;
    svg {
      width: 24px;
      height: 24px;
    }
    .price {
      font-size: 30px;
    }
    .original-price {
      color: rgba(178, 184, 187, 1);
      font-size: 14px;
      font-weight: 400;
      text-decoration: line-through;
      margin-left: 10px;
    }
  }
  .extra-welfare {
    .tip-text {
      color: #ffffff;
      height: 20px;
      width: 100%;
      margin-bottom: 6px;
      font-size: 12px;
    }
    .gift-amount {
      padding: 0 8px;
      font-size: 14px;
      line-height: 26px;
      color: #ffffff;
      background: ${(p) =>
        p.isActive ? "rgba(19, 203, 117, 0.15)" : "rgba(255, 255, 255, 0.06)"};
      border-radius: 20px;
      display: flex;
      align-items: center;
      width: 100%;
      margin-bottom: 6px;
      svg {
        margin-right: 6px;
        fill: ${(p) => (p.isActive ? "var(--main-color)" : "#727E84")};
      }
    }
  }
  :hover {
    background: rgba(19, 203, 117, 0.04);
    ${beforeCss};
    .gift-amount {
      background: rgba(19, 203, 117, 0.15);
      svg {
        fill: var(--main-color);
      }
    }
  }
`;

export const CommonSecondTabsContent = styled.div`
  border: 1px solid #495359;
  border-radius: 4px;
  .renderbus-ui-tab {
    border-radius: 4px;
  }
`;

export const CommonTitle = styled.div`
  color: #e8eef9;
  font-size: 14px;
  font-weight: 600;
`;

export const CommonUpperPart = styled.div`
  min-height: 300px;
`;

export const CommonCornerMark = styled.div`
  position: absolute;
  left: 0px;
  top: -12px;
  height: 26px;
  padding: 4px 12px;
  background: linear-gradient(90deg, #2edb8a 0%, #13c5cb 100%);
  border-radius: 6px 2px 6px 0px;
  color: #ffffff;
  font-weight: 600;
  font-size: 12px;
`;

export const ActivityRuleAndCoupon = styled.div`
  position: absolute;
  right: 0;
  top: -48px;
  display: flex;
`;

export const PictureCouponCode = styled.div`
  color: var(--main-color);
  cursor: pointer;
  margin-left: 16px;
`;
